__turbopack_context__.v({
  "SSpeechBubbleSvg": "KW0Ttq_SSpeechBubbleSvg",
});
